import {
  ForbiddenError,
  RateLimitError,
  ResourceNotFoundError,
  UnauthorizedError,
} from '@vimeo/core/libs/errors';
import { ErrorPage as CoreErrorPage } from '@vimeo/ui/core/ErrorPage';

function getError(error: { code: number; message: string | null }) {
  const message = error.message ?? undefined;
  switch (error.code) {
    case 401:
      return new UnauthorizedError(message);
    case 403:
      return new ForbiddenError(message);
    case 404:
      return new ResourceNotFoundError(message);
    case 429:
      return new RateLimitError(message);
    default:
      return new Error(message);
  }
}

export default function ErrorPage({ error }: { error: { code: number; message: string } }) {
  return (
    <div style={{ margin: '20vh 2vw' }}>
      <CoreErrorPage error={getError(error)} shouldShowSearch={false} />
    </div>
  );
}
